import React, { useState, useEffect, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./datefilter.css";
import { getTodayDate } from "../../serviceActiveCheck/serviceActiveCheck";

const DateFilter = ({
  onFilterChange,
  activeFilter,
  setActiveFilter,
  type = "",
  selectedDate,
}) => {
  const isOpen = activeFilter === "date";

  // UI state synced from parent
  const [localSelectedDate, setLocalSelectedDate] = useState("");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  // 🔄 Sync parent → UI
  useEffect(() => {
    const map = {
      Today: "Today",
      Last7Days: "Last 7 Days",
      Last30Days: "Last 30 Days",
      Custom: "Custom",
      All: "All",
    };

    setLocalSelectedDate(map[selectedDate] || "Last 7 Days");
  }, [selectedDate]);

  const dateOptions = useMemo(() => {
    if (type === "History" || type === "Statement") {
      return [
        { label: "Today" },
        { label: "Last 7 Days" },
        { label: "Last 30 Days" },
        { label: "Custom" },
      ];
    }

    return [
      { label: "All" },
      { label: "Today" },
      { label: "Last 7 Days" },
      { label: "Last 30 Days" },
      { label: "Custom" },
    ];
  }, [type]);

  const handleDateSelect = (label) => {
    setLocalSelectedDate(label);

    if (label !== "Custom") {
      setCustomStartDate("");
      setCustomEndDate("");
      setTempStartDate("");
      setTempEndDate("");

      onFilterChange({
        selectedDate: label,
        customStartDate: "",
        customEndDate: "",
      });

      setActiveFilter(null);
    }
  };

  const handleApplyCustomDate = () => {
    setCustomStartDate(tempStartDate);
    setCustomEndDate(tempEndDate);

    onFilterChange({
      selectedDate: "Custom",
      customStartDate: tempStartDate,
      customEndDate: tempEndDate,
    });

    setActiveFilter(null);
  };

  const handleToggle = () => {
    setActiveFilter(isOpen ? null : "date");
  };

  return (
    <div className="filter-dropdown-container-history-v">
      <button className="filter-button-history-v" onClick={handleToggle}>
        <CalendarTodayIcon style={{ width: "17px" }} />
        {["All"].includes(localSelectedDate)
          ? "DateFilter"
          : localSelectedDate}
        <ArrowDropDownIcon />
      </button>

      {isOpen && (
        <div className="status-dropdown-v">
          <div className="dropdown-header-v">
            <h3>DateFilter</h3>
            <button
              className="close-button-settlement"
              onClick={() => setActiveFilter(null)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="status-options-v">
            {dateOptions.map((option) => (
              <label key={option.label} className="status-option-v date-option">
                <input
                  type="radio"
                  name="date"
                  checked={localSelectedDate === option.label}
                  onChange={() => handleDateSelect(option.label)}
                />
                <span className="radio-text-v">{option.label}</span>
              </label>
            ))}

            {localSelectedDate === "Custom" && (
              <>
                <div className="custom-date-range">
                  <div className="date-input-container">
                    <input
                      type="date"
                      value={tempStartDate}
                      max={getTodayDate()}
                      onChange={(e) => setTempStartDate(e.target.value)}
                      className="date-input"
                    />
                    <CalendarTodayIcon className="calendar-icon" />
                  </div>

                  <span className="date-separator">To</span>

                  <div className="date-input-container">
                    <input
                      type="date"
                      value={tempEndDate}
                      min={tempStartDate}
                      max={getTodayDate()}
                      onChange={(e) => setTempEndDate(e.target.value)}
                      className="date-input"
                    />
                    <CalendarTodayIcon className="calendar-icon" />
                  </div>
                </div>

                <div className="apply-button-container">
                  <button
                    className="apply-button"
                    disabled={!tempStartDate || !tempEndDate}
                    onClick={handleApplyCustomDate}
                  >
                    Apply
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DateFilter;

// import React, { useState, useEffect, useMemo } from "react";
// import CloseIcon from "@mui/icons-material/Close";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import "./datefilter.css";
// import { getTodayDate } from "../../serviceActiveCheck/serviceActiveCheck";

// const DateFilter = ({
//   onFilterChange,
//   activeFilter,
//   setActiveFilter,
//   type = "",
// }) => {
//   console.log("onFilterChange activeFilter setActiveFilter type ====>>>", type, activeFilter)
//   const [selectedDate, setSelectedDate] = useState("");

//   const [customStartDate, setCustomStartDate] = useState("");
//   const [customEndDate, setCustomEndDate] = useState("");

//   const [tempStartDate, setTempStartDate] = useState("");
//   const [tempEndDate, setTempEndDate] = useState("");

//   const isOpen = activeFilter === "date";

//   useEffect(() => {
//     setSelectedDate(type === "History" ? "Last 7 Days" : "All");
//   }, [type]);

//   const dateOptions = useMemo(() => {
//     switch (type) {
//       case "History":
//         return [
//           { label: "Today", value: "today" },
//           { label: "Last 7 Days", value: "last7days" },
//           { label: "Last 30 Days", value: "last30days" },
//           { label: "Custom", value: "custom" },
//         ];

//       default:
//         return [
//           { label: "All", value: "All" },
//           { label: "Today", value: "today" },
//           { label: "Last 7 Days", value: "last7days" },
//           { label: "Last 30 Days", value: "last30days" },
//           { label: "Custom", value: "custom" },
//         ];
//     }
//   }, [type]);

//   useEffect(() => {
//     if (selectedDate !== "Custom") {
//       onFilterChange({
//         selectedDate,
//         customStartDate: "",
//         customEndDate: "",
//       });
//     }
//   }, [selectedDate]);

//   const handleDateSelect = (dateValue) => {
//     console.log("dateValue ====>>", dateValue)
//     setSelectedDate(dateValue);
//     if (dateValue !== "Custom") {
//       setCustomStartDate("");
//       setCustomEndDate("");
//       setTempStartDate("");
//       setTempEndDate("");
//       setActiveFilter(null); // Close filter if not custom
//     }
//   };

//   const handleApplyCustomDate = () => {
//     setCustomStartDate(tempStartDate);
//     setCustomEndDate(tempEndDate);
//     onFilterChange({
//       selectedDate: "Custom",
//       customStartDate: tempStartDate,
//       customEndDate: tempEndDate,
//     });
//     setActiveFilter(null); // close dropdown
//   };

//   const handleToggle = () => {
//     setActiveFilter(isOpen ? null : "date");
//   };

//   return (
//     <div className="filter-dropdown-container-history-v">
//       <button className="filter-button-history-v" onClick={handleToggle}>
//         <CalendarTodayIcon
//           className="category-icon"
//           style={{ width: "17px" }}
//         />
//         {["All", "Last 7 Days"].includes(selectedDate)
//           ? "DateFilter"
//           : selectedDate}
//         <ArrowDropDownIcon />
//       </button>

//       {isOpen && (
//         <div className="status-dropdown-v">
//           <div className="dropdown-header-v">
//             <h3>DateFilter</h3>
//             <button
//               className="close-button-settlement"
//               onClick={() => setActiveFilter(null)}
//             >
//               <CloseIcon />
//             </button>
//           </div>

//           <div className="status-options-v">
//             {dateOptions.map((option) => (
//               <div key={option.value} className="status-option-v">
//                 <label className="date-option">
//                   <input
//                     type="radio"
//                     name="date"
//                     value={option.value}
//                     checked={selectedDate === option.label}
//                     onChange={() => handleDateSelect(option.label)}
//                   />
//                   <span className="radio-text-v">{option.label}</span>
//                 </label>
//               </div>
//             ))}

//             {selectedDate === "Custom" && (
//               <>
//                 <div className="custom-date-range">
//                   <div className="date-input-container">
//                     <input
//                       type="date"
//                       value={tempStartDate}
//                       onChange={(e) => setTempStartDate(e.target.value)}
//                       max={getTodayDate()}
//                       className="date-input"
//                     />
//                     <CalendarTodayIcon className="calendar-icon" />
//                   </div>
//                   <span className="date-separator">To</span>
//                   <div className="date-input-container">
//                     <input
//                       type="date"
//                       value={tempEndDate}
//                       onChange={(e) => setTempEndDate(e.target.value)}
//                       min={
//                         tempStartDate || new Date().toISOString().split("T")[0]
//                       }
//                       max={getTodayDate()}
//                       className="date-input"
//                     />
//                     <CalendarTodayIcon className="calendar-icon" />
//                   </div>
//                 </div>
//                 <div className="apply-button-container">
//                   <button
//                     className="apply-button"
//                     disabled={!tempStartDate || !tempEndDate}
//                     onClick={handleApplyCustomDate}
//                   >
//                     Apply
//                   </button>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DateFilter;
